export default {
  other: {
    0o5: {
      output: true,
      labels: Array(15).fill('-'),
    },
    0o6: {
      output: true,
      labels: Array(15).fill('-'),
    },
    0o10: {
      output: true,
      labels: Array(15).fill('-'),
    },
    0o11: {
      output: true,
      labels: Array(15).fill('-'),
    },
    0o12: {
      output: true,
      labels: Array(15).fill('-'),
    },
    0o13: {
      output: true,
      labels: Array(15).fill('-'),
    },
    0o14: {
      output: true,
      labels: Array(15).fill('-'),
    },
    0o15: {
      output: false,
      labels: Array(15).fill('-'),
    },
    0o16: {
      output: false,
      labels: Array(15).fill('-'),
    },
    0o30: {
      output: false,
      labels: Array(15).fill('-'),
    },
    0o31: {
      output: false,
      labels: Array(15).fill('-'),
    },
    0o32: {
      output: false,
      labels: Array(15).fill('-'),
    },
    0o33: {
      output: false,
      labels: Array(15).fill('-'),
    },
    0o77: {
      output: false,
      labels: Array(15).fill('-'),
    },
  },
  LM: {
    0o5: {
      output: true,
      labels: [
        'RCS Jet B4U (1)',
        'RCS Jet A4D (2)',
        'RCS Jet A3U (5)',
        'RCS Jet B3D (6)',
        'RCS Jet B2U (9)',
        'RCS Jet A2D (10)',
        'RCS Jet A1U (13)',
        'RCS Jet B1D (14)',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
      ],
    },
    0o6: {
      output: true,
      labels: [
        'RCS Jet B3A (7)',
        'RCS Jet B4F (3)',
        'RCS Jet A1F (15)',
        'RCS Jet A2A (1)',
        'RCS Jet B2L (12)',
        'RCS Jet A3R (8)',
        'RCS Jet A4R (4)',
        'RCS Jet B1L (16)',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
      ],
    },
    0o10: {
      output: true,
      labels: [
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit Selector',
        'DSKY Digit Selector',
        'DSKY Digit Selector',
        'DSKY Digit Selector',
      ],
    },
    0o11: {
      output: true,
      labels: [
        'ISS Warning',
        'Computer Activity Lamp',
        'Uplink Activity Lamp',
        'Temperature Caution Lamp',
        'Keyboard Release Lamp',
        'Flash Verb and Noun Lamps',
        'Operator Error Lamp',
        'Spare',
        'Test Connector Outbit',
        'Caution Reset',
        'Spare',
        'Spare',
        'Eng. On',
        'Eng. Off',
        'Spare',
      ],
    },
    0o12: {
      output: true,
      labels: [
        'Zero RR CDU\'s',
        'Enable RR Error Counters',
        'Not Used',
        'Coarse Align Enable',
        'Zero IMU CDU\'s',
        'Enable IMU Error Counters',
        'Spare',
        'Display Inertial Data',
        '+ Pitch Vehicle Motion', // (Pitch Gimbal Trim, Bell motion)',
        '- Pitch Vehicle Motion', // (Pitch Gimbal Trim, Bell motion)',
        '+ Roll Vehicle Motion', // (Pitch Gimbal Trim, Bell motion)',
        '- Roll Vehicle Motion', // (Pitch Gimbal Trim, Bell motion)',
        '', // omitted?
        'RR Enable Auto Track',
        'ISS Turn-on Delay Compl',
      ],
    },
    0o13: {
      output: true,
      labels: [
        'Radar Select c',
        'Radar Select b',
        'Radar Select a',
        'Radar Activity',
        'Inh. Uplink, En. Crosslnk',
        'Block Inlink',
        'Downlink Word Order',
        'RHC Counter Enable',
        'Start RHC Read',
        'Test Alarms',
        'Enable Standby',
        'Reset Trap 31-A',
        'Reset Trap 31-B',
        'Reset Trap 32',
        'Enable T6RUPT',
      ],
    },
    0o14: {
      output: true,
      labels: [
        'Outlink Activity',
        'Altitude Rate Select',
        'Altitude Meter Activity',
        'Thrust Drive',
        'Spare',
        'Gyro Enable',
        'Gyro Select b',
        'Gyro Select a',
        'Gyro Sign Minus',
        'Gyro Activity',
        'Drive CDU S',
        'Drive CDU T',
        'Drive CDU Z',
        'Drive CDU Y',
        'Drive CDU X',
      ],
    },
    0o15: {
      output: false,
      labels: [
        'Main DSKY key code',
        'Main DSKY key code',
        'Main DSKY key code',
        'Main DSKY key code',
        'Main DSKY key code',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
      ],
    },
    0o16: {
      output: false,
      labels: [
        'Spare',
        'Spare',
        'Mark X',
        'Mark Y',
        'Mark Reject',
        'Descent +',
        'Descent -',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
      ],
    },
    0o30: {
      output: false,
      labels: [
        'Abort with Descent Stage',
        'Descent Stage Attached',
        'Eng. Armed',
        'Abort with Ascent Stage',
        'Auto Throttle',
        'Display Inertial Data',
        'RR CDU Fail',
        'Spare',
        'IMU Operate',
        'G/N Control of S/C',
        'IMU Cage',
        'IMU CDU Fail',
        'IMU Fail',
        'ISS Turn-On Request',
        'Temp in Limits',
      ],
    },
    0o31: {
      output: false,
      labels: [
        '+ EL (LPD), + PMI',
        '- EL (LPD), + PMI',
        '+ YMI',
        '- YMI',
        '+ AZ (LPD), + RMI',
        '- AZ (LPD), + RMI',
        '+X Translation',
        '-X Translation',
        '+Y Translation',
        '-Y Translation',
        '+Z Translation',
        '-Z Translation',
        'Att. Hold',
        'Auto Stabilization',
        'Att. Control Detent',
      ],
    },
    0o32: {
      output: false,
      labels: [
        'Thruster 2-4 Disable',
        'Thruster 5-8 Disable',
        'Thruster 1-3 Disable',
        'Thruster 6-7 Disable',
        'Thruster 14-16 Disable',
        'Thruster 13-15 Disable',
        'Thruster 9-12 Disable',
        'Thruster 10-11 Disable',
        'Desc. Eng. Gimbals Dis.',
        'Desc. Eng. Gimbal Fail',
        'Spare',
        'Spare',
        'Spare',
        'Proceed',
        'Spare',
      ],
    },
    0o33: {
      output: false,
      labels: [
        'Spare',
        'RR Auto-Power On',
        'RR Range Low Scale',
        'RR Data Good',
        'LR Range Data Good',
        'LR Position 1',
        'LR Position 2',
        'LR Velocity Data Good ',
        'LR Range Low Scale',
        'Block Uplink Input',
        'Uplink Too Fast',
        'Downlink Too Fast',
        'PIPA Fail',
        'LGC Warning', // (repeated hardware or software alarms)',
        'Oscillator Alarm',
      ],
    },
    0o77: {
      output: false,
      labels: [
        'E or F Memory Parity Fail',
        'E Memory Parity Fail',
        'TC Trap',
        'RUPT Lock',
        'Night Watchman',
        'Voltage Fail',
        'Counter Fail',
        'Scaler Fail',
        'Scaler Double Frequency',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
      ],
    },
  },
  CM: {
    0o5: {
      output: true,
      labels: [
        'C-3/I-3',
        'C-4/2-4',
        'A-3/2-3',
        'A-4/1-4',
        'D-3/2-5',
        'D-4/1-6',
        'B-3/1-5',
        'B-4/2-6',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
      ],
    },
    0o6: {
      output: true,
      labels: [
        'B-1/1-1',
        'B-2/1-2',
        'D-1/2-1',
        'D-2/2-2',
        'A-1',
        'A-2',
        'C-1',
        'C-2',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
        'not used',
      ],
    },
    0o10: {
      output: true,
      labels: [
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
        'DSKY Digit',
      ],
    },
    0o11: {
      output: true,
      labels: [
        'ISS Warning',
        'Computer Activity Lamp',
        'Uplink Activity Lamp',
        'Temperature Caution Lamp',
        'Keyboard Release Lamp',
        'Flash Verb and Noun Lamps',
        'Operator Error Lamp',
        'Spare',
        'Test Connector Outbit',
        'Caution Reset',
        'Spare',
        'Spare',
        'Eng. On/Off',
        'Spare',
        'Spare',
      ],
    },
    0o12: {
      output: true,
      labels: [
        'Zero Optics CDU\'s',
        'En. Optics COU Err Cntrs',
        'Not Used',
        'Coarse Align Enable',
        'Zero IMU CDU\'s',
        'En. IMU Err Cntrs',
        'Spare',
        'TVC Enable',
        'Enable S-IVB Takeover',
        'Zero Optics',
        'Disengage Optics DAC',
        'Spare',
        'S-IVB Injection Seq Start',
        'S-IVB Cutoff',
        'ISS Turn-on Delay Compl',
      ],
    },
    0o13: {
      output: true,
      labels: [
        'Range Unit Select c',
        'Range Unit Select b',
        'Range Unit Select a',
        'Range Unit Activity',
        'Not Used',
        'Block Inlink',
        'Downlink Word Order Code Bit',
        'Not Used',
        'Spare',
        'Test Alarms',
        'Enable Standby',
        'Reset Trap 31-A',
        'Reset Trap 31-B',
        'Reset Trap 32',
        'Enable T6RUPT',
      ],
    },
    0o14: {
      output: true,
      labels: [
        'Not Used',
        'Spare',
        'Spare',
        'Spare',
        'Not Used',
        'Gyro Enable',
        'Gyro Select b',
        'Gyro Select a',
        'Gyro Sign (1 = minus)',
        'Gyro Activity',
        'Drive CDU S',
        'Drive CDU T',
        'Drive CDU Z',
        'Drive CDU Y',
        'Drive CDU X',
      ],
    },
    0o15: {
      output: false,
      labels: [
        'Main DSKY key code',
        'Main DSKY key code',
        'Main DSKY key code',
        'Main DSKY key code',
        'Main DSKY key code',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
      ],
    },
    0o16: {
      output: false,
      labels: [
        'Nav DSKY key code',
        'Nav DSKY key code',
        'Nav DSKY key code',
        'Nav DSKY key code',
        'Nav DSKY key code',
        'Mark Button',
        'Mark Reject Button',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
      ],
    },
    0o30: {
      output: false,
      labels: [
        'Ullage Thrust Percent',
        'CM/SM Separate',
        'SPS Ready',
        'S-IVB Separate, Abort',
        'Liftoff',
        'Guidance Reference Release',
        'Optics CDU Fail',
        'Spare',
        'IMU Operate',
        'S/C Control of Saturn',
        'IMU Cage',
        'IMU CDU Fail',
        'IMU Fail',
        'ISS Turn-On Request',
        'Temp in Limits',
      ],
    },
    0o31: {
      output: false,
      labels: [
        '+ Pitch Manual Rotation',
        '- Pitch Manual Rotation',
        '+ Yaw Manual Rotation',
        '- Yaw Manual Rotation',
        '+ Roll Manual Rotation',
        '- Roll Manual Rotation',
        '+X Translation',
        '-X Translation',
        '+Y Translation',
        '-Y Translation',
        '+Z Translation',
        '-Z Translation',
        'Hold Function',
        'Free Function',
        'G&N Autopilot Control',
      ],
    },
    0o32: {
      output: false,
      labels: [
        '+ Pitch Minimum Impulse',
        '- Pitch Minimum Impulse',
        '+ Yaw Minimum Impulse',
        '- Yaw Minimum Impulse',
        '+ Roll Minimum Impulse',
        '- Roll Minimum Impulse',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'LM Attached',
        'Spare',
        'Spare',
        'Proceed (Standby button)',
        'Spare',
      ],
    },
    0o33: {
      output: false,
      labels: [
        'Spare',
        'Range Unit Data Good',
        'Spare',
        'Zero Optics',
        'CMC Control',
        'Not Used',
        'Not Used',
        'Spare',
        'Spare',
        'Block Uplink Input',
        'Uplink Too Fast',
        'Downlink Too Fast',
        'PIPA Fail',
        'AGC Warning',
        'AGC Oscillator Alarm',
      ],
    },
    0o77: {
      output: false,
      labels: [
        'E or F Memory Parity Fail',
        'E Memory Parity Fail',
        'TC Trap',
        'RUPT Lock',
        'Night Watchman',
        'Voltage Fail',
        'Counter Fail',
        'Scaler Fail',
        'Scaler Double Freq Alarm',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
        'Spare',
      ],
    },
  },
};
